import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  disabledCurrencyHyperlink: {
    color: '#1942C5',
    fontWeight: 500,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    cursor: 'pointer',
    textDecoration: 'none',
    pointerEvents: 'auto !important' as 'auto',
  },
  modalExternalLink: {
    fontSize: `12px !important`,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#1942C5',
  },
  externalLinkMain: {
    fontSize: `14px !important`,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#1942C5',
    letterSpacing: '0.1px',
  },
  noteText: {
    fontSize: `14px !important`,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#191C1D',
  },
  importantText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#191C1D',
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(3),
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#2E3132',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  toolTipIcon: {
    color: theme.palette.textField.main,
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: theme.spacing(0, 0.75),
    cursor: 'pointer',
  },
  modalHeader: {
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2),
    color: '#2E3132',
  },
  checkbox: {
    marginTop: theme.spacing(0.625),
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: theme.spacing(2),
    color: '#2E3132',
  },
  modalContent: {
    display: 'flex',
    gap: theme.spacing(2),
    width: `${theme.spacing(52.5)} !important`,
    flexDirection: 'column',
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: theme.spacing(2),
  },
  disabledText: {
    color: theme.palette.labraText.description,
    cursor: 'not-allowed',
  },
  menuItems: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  selector: {
    width: theme.spacing(53.5),
  },
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(2),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  fontColor: {
    color: '#2E3132',
  },
  sectionText: {
    fontSize: `${theme.spacing(1.75)} !important`,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: `${theme.spacing(2.5)} !important`,
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  subContainer: {
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    width: '100%',
  },
  field: {
    width: theme.spacing(60.625),
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    alignSelf: 'stretch',
  },
  checkboxWidth: {
    width: theme.spacing(30.5),
  },
  productTypeChangeText: {
    color: theme.palette.labraText.description,
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
  },
  productTypeChangeTextNote: {
    fontWeight: 600,
  },
  productTypeChangeConfirmText: {
    marginBottom: theme.spacing(1.5),
  },
  fullWidth: {
    width: '100%',
  },
  containerMargin: {
    marginBottom: theme.spacing(-2),
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2),
  },
  checkboxContainerTooltip: {
    width: '100%',
  },
  noteWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}))
